module.exports = __webpack_public_path__ + "img/illustration.b5f73e7a.svg";